import { render, staticRenderFns } from "./radar_fist.vue?vue&type=template&id=348f1bfa&"
import script from "./radar_fist.vue?vue&type=script&lang=js&"
export * from "./radar_fist.vue?vue&type=script&lang=js&"
import style0 from "./radar_fist.vue?vue&type=style&index=0&id=348f1bfa&prod&lang=less&scopded=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports